import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import { loadFavourites, toggleFavourite } from './tep-species.actions';
import { append, includes, without } from '@qld-recreational/ramda';
import { switchUser } from '../auth/auth.actions';

export const tepSpeciesFeatureKey = 'tep-species';

export interface ITepSpeciesState {
  favouriteTepSpecies: Array<number>;
}

export const initialState: ITepSpeciesState = {
  favouriteTepSpecies: [],
};

export const reducer = createReducer(
  initialState,
  on(loadFavourites, (state, action) => ({
    ...state,
    favouriteTepSpecies: Array.from(new Set(action.caabCodes)),
  })),
  on(toggleFavourite, (state, action) => {
    let favouriteTepSpecies = [...state.favouriteTepSpecies];
    favouriteTepSpecies = includes(action.caabCode, favouriteTepSpecies)
      ? without([action.caabCode], favouriteTepSpecies)
      : append(action.caabCode, favouriteTepSpecies);
    return { favouriteTepSpecies };
  }),
  on(switchUser, () => initialState),
);

export const selectTepSpeciesState =
  createFeatureSelector<ITepSpeciesState>(tepSpeciesFeatureKey);

export const selectFavouriteTepSpecies = createSelector(
  selectTepSpeciesState,
  (state) => state.favouriteTepSpecies,
);
